<style scoped>

</style>

<template>
    <div>
        <ModalComponent ref="modal" title="Commander" size="modal-xxl" bg-color="supplying" :can-reset="true" :is-force-refresh="true">
            <div class="text-xs">
                <template v-if="moHistory.length > 0">
                    <OrderPopupList title="Commandes Projets - <strong>Corrections</strong>" :list="moHistory" :cies="cies" :is-history="true"></OrderPopupList>
                </template>
                <OrderPopupList title="Commandes Projets" :list="orders" :cies="cies" :is-order="true"></OrderPopupList>
                <template v-if="ordersBE.length > 0">
                    <OrderPopupList title="Commandes Externes" :list="ordersBE" :cies="cies" :is-order="true"></OrderPopupList>
                </template>
                <template v-if="ordersInv.length > 0">
                    <OrderPopupList title="Achats d'Inventaires" :list="ordersInv" :cies="cies" :is-order="true"></OrderPopupList>
                </template>
                <template v-if="projectReturn.length > 0">
                    <OrderPopupList title="Retours Matériel" :list="projectReturn" :cies="cies" :is-return="true"></OrderPopupList>
                </template>
                <template v-if="inventoryReturn.length > 0">
                    <OrderPopupList title="Retours Inventaire" :list="inventoryReturn" :cies="cies" :is-inventory-return="true"></OrderPopupList>
                </template>
            </div>
        </ModalComponent>
        <ToastComponent ref="toast"></ToastComponent>
        <ToastComponent ref="printToast" :is-bottom="true"></ToastComponent>
    </div>
</template>

<script>

import ModalComponent from "@/components/_shared/ModalComponent.vue";
import ToastComponent from "@/components/_shared/ToastComponent.vue";
import OrderPopupList from '@/components/order/OrderPopupList.vue';
export default {
    name: "OrderPopup",
    components: { OrderPopupList, ToastComponent, ModalComponent},
    props: {},
    data() {
        return {
            orders: [],
            ordersBE: [],
            ordersInv: [],
            returns: [],
            projectReturn: [],
            inventoryReturn: [],
            moHistory: [],
            cies: [],
        }
    },
    computed: {
        MaterialOperationTypeEnum() {
            return this.$store.enumsStore.MaterialOperationType;
        },
        AddressTypeEnum() {
            return this.$store.enumsStore.AddressType;
        },
        defaultCie() {
            return parseInt(this.$store.constantStore.getConstantByVariable('NO_CIE_DEFAULT').value);
        },
        dataChanged() {
            return this.orders.some(order => order.is_order) 
                || this.ordersBE.some(orderBE => orderBE.is_order)
                || this.ordersInv.some(orderInv => orderInv.is_order)
                || this.projectReturn.some(projectReturn => projectReturn.is_return)
                || this.inventoryReturn.some(inventoryReturn => inventoryReturn.is_return)
                || this.moHistory.some(moHistory => moHistory.is_order);
        }
    },
    methods: {
        async getAllCies() {
            await this.$axios.get('/CieActiveWithDetails').then((response) => {
                this.cies = response;
            });
        },
        getContactForCie(cieId, details) {
            if (this.cies.length === 0) { return; }

            const cie = this.cies?.find(cie => cie.id === cieId);

            if (details.vendorContact === undefined || Object.keys(details.vendorContact).length === 0) {
                if (details.bc_contact_id  > 0) {
                    details.vendorContact = cie.contact.find(contact => contact.id === details.bc_contact_id);
                } else if (cie.bc_contact_id > 0) {
                    details.vendorContact = cie.contact.find(contact => contact.id === cie.bc_contact_id);
                } else {
                    details.vendorContact = cie.contact[0];
                }
            }

            return cie.contact;
        },
        getDeliveryAddresses(cieId, details) {
            const cie = this.cies.find(cie => cie.id === cieId);
            let addresses = cie?.address?.filter(address => address.address_type_id === this.AddressTypeEnum.SHIPPING.id);

            if (!!addresses && addresses.length > 0) {
                addresses.forEach(address => {
                    address.full_name_delivery = `Livraison ${address.order} (${address.address})`;
                });

                if (details.delivery_address_id === null) {
                    details.delivery_address_id = addresses[0].id;
                }
            } else {
                addresses = [];
            }

            return addresses;
        },
        async open() {
            await this.getAllCies();
            await this.getOrdersReturns();

            this.$refs.modal.open();            
        },
        async getOrdersReturns() {
            await this.$axios.get('/OrdersReturnsWaiting').then((response) => {
                Object.keys(response).forEach(key => {
                    if(['orders', 'ordersBE', 'ordersInv'].includes(key)) {
                        this[key] = response[key].map(item => this.setupOrder(item));
                    } else if(key === 'returns') {
                        response[key].forEach(item => {
                            const mappedResult = this.setupReturn(item);
                            const type = ((item.return_type === this.MaterialOperationTypeEnum.RM.id) ? 'projectReturn' : 'inventoryReturn');
                            this[type].push(mappedResult);
                        });
                    } else {
                        this[key] = response[key];
                    }
                });
            });
        },
        setupOrder(order) {
            if (order.moNumber === null) {
                order.dispatch_received_cie_id = this.defaultCie;
                order.date_estimated_delivery = this.$general.getToday();
            } else {
                order.date_estimated_delivery = this.$general.formatDate(order.date_estimated_delivery);
            }

            return order;
        },
        setupReturn(r) {
            if (r.moStatus !== this.MaterialOperationTypeEnum.RM.status) {
                r.moNumber = null;
                r.date_estimated_delivery = this.$general.getToday();
                r.delivery_address_id = null;
            } else {
                r.date_estimated_delivery = this.$general.formatDate(r.date_estimated_delivery);
            }
            r.cie = this.cies.find(cie => cie.id === r.cie_id);

            return r;
        },
        
        async save() {
            const orders = this.orders.filter(order => order.is_order);
            const ordersBE = this.ordersBE.filter(order => order.is_order);
            const ordersInv = this.ordersInv.filter(order => order.is_order);
            const projectReturn = this.projectReturn.filter(returnInfo => returnInfo.is_return);
            const inventoryReturn = this.inventoryReturn.filter(returnInfo => returnInfo.is_return);
            const moHistory = this.moHistory.filter(moHistory => moHistory.is_order)

            if (orders.length === 0 && ordersBE.length === 0 && ordersInv.length === 0 && inventoryReturn.length === 0 
                && projectReturn.length === 0 && moHistory.length === 0
            ) {
                this.$refs.toast.setEverything('Commander','',`Vous n'avez pas sélectionnné de commandes ou de retours.`,'info');
                this.$refs.toast.show();
                return;
            } else {
                const payload = [
                    {type: 'order',   operations: orders,    isBE: false},
                    {type: 'order',   operations: ordersBE,  isBE: true},
                    {type: 'order',   operations: ordersInv, isBE: false},

                    {type: 'return',  operations: projectReturn},
                    {type: 'return',  operations: inventoryReturn},

                    {type: 'history', operations: moHistory}
                ];

                await this.$axios.post('/OrdersReturnsWaitingSave', { 
                    payload: payload.filter(p => p.operations.length > 0)
                }).then((response) => {
                    this.$refs.toast.setEverything('Commander','','Vos opérations ont bien été sauvegardées','save');
                    this.$refs.toast.show();
                });

                this.reset();
                await this.getOrdersReturns();
            }
        },
        reset() {
            this.orders = [];
            this.ordersBE = [];
            this.ordersInv = [];
            this.inventoryReturn = [];
            this.projectReturn = [];
            this.moHistory = [];
        },
        showPrintPopup() {
            this.$refs.printToast.setEverything('Commander', '', 'Création du PDF en cours.', 'info', false);
            this.$refs.printToast.show();
        }
    },
    watch: {},
}
</script>